import {components} from "react-select";
import React from "react";
import { Button } from "react-bootstrap";

// TODO: Merge with Option

const OptionItem = ({
    btnSize = "lg",
    btnVariant = "light",
    ...props
}) => {

    const onCheckChange = ({checked}) => {
        var data = {
            ...props.data,
            checked
        }
        if(props.selectProps.onCheckChange)
            props.selectProps.onCheckChange(data);
    }    

    return (
        <components.Option {...props}>
            <div className="option-wrapper">
                <Button
                    onClick={() => onCheckChange({checked: props.value})}
                    accessKey={props.data.key} 
                    size={btnSize} 
                    variant={btnVariant}
                    block
                >{props.label}</Button>
            </div>
        </components.Option>
    );
};

export default OptionItem;